interface StyleProcessorOptions {
  removeProperties?: string[];
}

export function processInlineStyles(
  styleString?: string | null,
  options: StyleProcessorOptions = {},
) {
  if (!styleString) {
    return {};
  }

  const styles = styleString.split(';').reduce(
    (acc, style) => {
      if (style.trim().length === 0) return acc;

      const [key, value] = style.split(':');
      const propertyKey = key.trim().replace(/-./g, (x) => x[1].toUpperCase());

      acc[propertyKey] = value.trim();
      return acc;
    },
    {} as Record<string, string>,
  );

  // Remove specified properties
  if (options.removeProperties) {
    for (const prop of options.removeProperties) {
      delete styles[prop];
    }
  }

  return styles;
}

export const BORDER_STYLE_PROPERTIES = [
  'border',
  'borderColor',
  'borderStyle',
  'borderWidth',
  'borderLeft',
  'borderRight',
  'borderTop',
  'borderBottom',
  'borderRadius',
  'borderCollapse',
  'borderSpacing',
  'borderInlineStart',
  'borderInlineEnd',
  'borderBlockStart',
  'borderBlockEnd',
];
